import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import AppText from "./AppText";
import { appStrings } from "./strings";
import { isValidEmail } from "../utils";
import "./Join.css";
import Button from "../../presentational/Button";
import Input from "../../presentational/Input";
import TryMDH from "./TryMDH";
import { useTurnstile } from "../../../hooks/useTurnstile";

interface JoinCoordinatorParameters {
    firstName: string;
    lastName: string;
    email: string;
    isLoading: boolean;
    serverError: string;
    loginLink: string;
    startJoin: () => void;
    setEmail: (email: string) => void;
    setFirstName: (firstName: string) => void;
    setLastName: (lastName: string) => void;
}

const JoinCoordinator: React.FC<JoinCoordinatorParameters> = ({
    firstName,
    lastName,
    email,
    isLoading,
    serverError,
    loginLink,
    setEmail,
    startJoin,
    setFirstName,
    setLastName,
}) => {
    useTurnstile();

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        startJoin();
        return false;
    };

    const handleChangeEmail = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(e.target.value);
    };
    const handleChangeFirstName = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFirstName(e.target.value);
    };
    const handleChangeLastName = (e: React.ChangeEvent<HTMLInputElement>) => {
        setLastName(e.target.value);
    };

    return (
        <main className="col-layout join-page">
        <div className="join-details">
            <h1>Design, launch, and manage digital health studies</h1>
            <img src="https://assets.careevolutionapps.com/CareEvolution/Images/MDHD/mdhd-infographic.svg" alt="MyDataHelps Designer Illustration" />
        </div>
        <div className="authentication-action">
            <div className="form-wrapper">
                <form className="form" onSubmit={handleSubmit}>
                    <div className="form-header">
                        <img className="form-header-logo" src="https://assets.careevolutionapps.com/CareEvolution/Images/MDHD/mdhd-blue-bug-logo-centered.svg" alt="MyDataHelps Designer Logo" />
                        <h2>
                            <AppText textKey="join-title" />
                        </h2>
                        <p className="small-print">
                            <AppText textKey="join-text" />
                            <br />
                            <a
                                href={appStrings["privacy-policy-link"]}
                                target="_blank"
                                style={{ whiteSpace: "nowrap" }}
                            >
                                <AppText textKey="join-privacy-link-label" />
                            </a>
                            .
                        </p>
                    </div>
                    {serverError && <p className="server-error">{serverError}</p>}
                    <div className="field-group">
                        <label className="field-group" htmlFor="joinFirstName">
                            <AppText textKey="first-name-label" />
                        </label>
                        <Input
                            inputClassName="admin-input"
                            fullWidth={true}
                            onChange={handleChangeFirstName}
                            disabled={isLoading}
                            id="joinFirstName"
                            type="text"
                            value={firstName}
                            placeholder={appStrings["first-name-placeholder"]}
                            autoComplete="given-name"
                            autoFocus={true}
                            htmlAttributes={{
                                spellCheck: false,
                                autoCorrect: "off",
                                autoCapitalize: "none",
                            }}
                        />
                    </div>
                    <div className="field-group">
                        <label className="field-group" htmlFor="joinLastName">
                            <AppText textKey="last-name-label" />
                        </label>
                        <Input
                            inputClassName="admin-input"
                            onChange={handleChangeLastName}
                            fullWidth={true}
                            disabled={isLoading}
                            id="joinLastName"
                            type="text"
                            value={lastName}
                            placeholder={appStrings["last-name-placeholder"]}
                            autoComplete="family-name"
                            htmlAttributes={{
                                spellCheck: false,
                                autoCorrect: "off",
                                autoCapitalize: "none",
                            }}
                        />
                    </div>
                    <div className="field-group">
                        <label className="field-group" htmlFor="joinEmail">
                            <AppText textKey="email-label" />
                        </label>
                        <Input
                            inputClassName="admin-input"
                            onChange={handleChangeEmail}
                            fullWidth={true}
                            disabled={isLoading}
                            id="joinEmail"
                            type="text"
                            value={email}
                            placeholder={appStrings["email-placeholder"]}
                            autoComplete="email"
                            htmlAttributes={{
                                spellCheck: false,
                                autoCorrect: "off",
                                autoCapitalize: "none",
                            }}
                        />
                        <p className="small-print">
                            <AppText textKey="join-email-disclaimer-text" />
                        </p>
                    </div>
                    <div className="field-group">
                        <div id="cf-turnstile" className="cf-turnstile"></div>
                    </div>
                    <Button
                        onClick={handleSubmit}
                        type="submit"
                        disabled={!isValidEmail(email) || !firstName || !lastName || isLoading}
                        className="primary-button editor-controls-button"
                        loading={isLoading}
                        intent="primary"
                    >
                        <span
                            dangerouslySetInnerHTML={{
                                __html: appStrings["next-label"],
                            }}
                        />
                    </Button>

                        <Link className="editor-controls-button text-button" to={loginLink}>
                            <span
                                className="plain-text"
                                dangerouslySetInnerHTML={{
                                    __html: appStrings["join-existing-account"],
                                }}
                            />{" "}
                            &nbsp;
                            <AppText textKey="sign-in-label" />
                        </Link>
                </form>
            </div>
            <TryMDH />
        </div>
        </main>
    );
};

export default JoinCoordinator;
